import {
  styled,
  Dialog,
  DialogTitle,
  Box,
  Typography,
  Checkbox,
  TableRow,
  TextField,
  TableCell,
  Button,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const styledDialog = {
  title: styled(DialogTitle)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: `${pxToRem(24)} !important`,
    alignItems: 'center',
    color: 'grey.800',
  })),
  content: styled(DialogContent)(() => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 24px',
  })),
  actions: styled(DialogActions)(() => ({
    padding: '16px 24px',
  })),
};

export const downloadDialog = {
  dialog: styled(Dialog)(() => ({
    maxWidth: '100vw',
    '.MuiPaper-root': {
      maxWidth: '100vw',
      width: '100vw',
      height: '716px',
    },
  })),
  title: styled(DialogTitle)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    [theme.breakpoints.down('tablet')]: {
      alignItems: 'start',
    },
  })),
  titleContent: styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    gap: '16px',
    alignItems: 'center',
    [theme.breakpoints.down('tablet')]: {
      flexDirection: 'column',
      alignItems: 'start',
      gap: '8px',
    },
  })),
  titleText: styled(Typography)(() => ({
    fontWeight: '500',
    fontSize: pxToRem(22),
    color: '#2B2825',
  })),
  textfield: styled(TextField)(({ theme }) => ({
    width: '60%',
    [theme.breakpoints.down('desktop')]: {
      width: 'calc(100% - 160px )',
    },
    [theme.breakpoints.down('tablet')]: {
      width: 'calc(100% + 26px)',
    },
    '.MuiInputBase-root': {
      borderRadius: '28px',
    },
  })),
};

export const downloadTable = {
  checkbox: styled(Checkbox)(() => ({
    color: '#FF7E34',
    '&.Mui-checked': {
      color: '#FF7E34',
    },
    '&.MuiCheckbox-indeterminate': {
      color: '#FF7E34',
    },
  })),
  headRow: styled(TableRow)(({ theme }) => ({
    '.MuiTableCell-head': {
      color: 'white',
      backgroundColor: theme.palette.primary.dark,
      backgroundImage: 'none',
    },
  })),
  cell: styled(TableCell)<{ width: string; isHeader?: boolean }>(
    ({ width, isHeader }) => ({
      minWidth: width === '100%' ? '193px' : width,
      width,
      padding: '8px 16px',
      wordBreak: 'break-all',
      ...(isHeader && {
        fontSize: '20px',
        fontWeight: '500',
      }),
    }),
  ),
  batchDownloadButton: styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.dark,
    '&:hover': { backgroundColor: '#AE3D1A' },
  })),
};
